<template>
	<div class="form">
		<GuestErrors
			:class="Object.keys(errors).length > 0 ? 'd-block' : 'd-none'"
		>
			<span class="d-block" v-for="error in errors" :key="error">{{
				error[0]
			}}</span>
		</GuestErrors>
		<div class="" v-if="loading">
			Espera, estamos verificando el enlace.
		</div>
		<div v-else>
			<GuestHeading>Restablecer la contraseña</GuestHeading>
			<GuestInput
			 v-model="email"
			:class="errors.email ? 'is-invalid':''"
			type="email" placeholder="Email" name="email"/>	
			<div style="position: relative;">
				<GuestPassword v-model="password" :placeholder="`Contraseña`" :class="errors.password ? 'is-invalid':''"/>
			</div>
			<div style="position:relative;">
				<GuestPassword v-model="password_confirmation" :placeholder="`Repetir contraseña`" :class="errors.password_confirmation ? 'is-invalid':''"/>
			</div>
			<GuestButton @click.prevent="handleSubmit">Cambia la contraseña</GuestButton>
		</div>
	</div>
</template>

<script>
import GuestPassword from '../../components/GuestPassword.vue'
import GuestErrors from '../../components/GuestErrors.vue'
import GuestHeading from '../../components/GuestHeading.vue'
import GuestInput from '../../components/GuestInput.vue'
import GuestButton from '../../components/GuestButton.vue'
import EyeButton from '../../components/EyeButton.vue'
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import User from "@/api/User";

export default {
	name: "ResetPassword",
	components: { GuestErrors, GuestHeading, GuestInput, EyeButton, GuestButton, GuestPassword},
		setup() {
		const errors = ref({});
		const email = ref("");
		const password = ref("");
		const password_confirmation = ref("");
		const store = useStore();
		const route = useRoute();
		const router = useRouter();
		store.dispatch('loading',true)
		
		User.verifyResetPasswordLink(route.query)
			.then((response) => {
				if (response.status == 200) {
					errors.value = {}
					store.dispatch('loading',false)
				}
			})
			.catch((errs) => {
				// validation error
				if (errs.response.status == 422) {
					errors.value = errs.response.data.errors;
				}
				else{
					errors.value = {'errors':{'email': ["something went wrong please try again"]}};
				}
			});
		const handleSubmit = ()=>{
			User.updatePassword({email: email.value, password: password.value, password_confirmation: password_confirmation.value, params: route.query})
				.then((response) => {
					debugger;
					console.log(response);
					if (response.status == 200) {
						errors.value = response.data.errors;
						router.push({name: 'Login'})
					}
					// validation error
					if (response.status == 422) {
						errors.value = response.data.errors;
					}
				})
				.catch((errs) => {
					// validation error
					if (errs.response.status == 422) {
						errors.value = errs.response.data.errors;
					}
					else{
						errors.value = {'errors':{'email': ["something went wrong please try again"]}};
					}
				});
		}

		return {
			loading: store.getters.loading,
			errors,
			email,
			password,
			password_confirmation,
			handleSubmit
		};
	},
};
</script>

<style scoped>
	div.form {
		position: relative;
		z-index: 1;
		background: #FFFFFF;
		max-width: 360px;
		padding: 45px;
		text-align: center;
		box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
	}
</style>
